export default __webpack_public_path__ + "static/HeldaneDisplayWeb-Medium-1c62a0084bd66a5feb505a7cf78f113f.eot";